interface InterfaceFacts {
  id: number;
  fact: string;
}

export const facts: InterfaceFacts[] = [
  {
    id: 1,
    fact: "Lambeau Field in Green Bay, Wisconsin, is the oldest continuously operating NFL stadium, opening in 1957.",
  },
  {
    id: 2,
    fact: "The Minnesota Vikings’ U.S. Bank Stadium has transparent ETFE roof panels and the largest pivoting glass doors in the world.",
  },
  {
    id: 3,
    fact: `The Dallas Cowboys' AT&T Stadium has the world’s largest high-definition video screen, spanning from one 20-yard line to the other.`,
  },
  {
    id: 4,
    fact: "The Superdome in New Orleans was used as a shelter during Hurricane Katrina in 2005.",
  },
  {
    id: 5,
    fact: "Soldier Field in Chicago is the oldest NFL stadium still in use, originally opening in 1924 and later renovated in 2003.",
  },
  {
    id: 6,
    fact: "CenturyLink Field in Seattle is known for its intense crowd noise, which has been measured as the loudest in the NFL.",
  },
  {
    id: 7,
    fact: `The Arizona Cardinals' State Farm Stadium features a retractable grass field that can be moved outside to grow.`,
  },
  {
    id: 8,
    fact: "MetLife Stadium, home to both the New York Giants and New York Jets, is the only NFL stadium shared by two teams.",
  },
  {
    id: 9,
    fact: "The Mercedes-Benz Stadium in Atlanta has a unique retractable roof that opens and closes like a camera aperture.",
  },
  {
    id: 10,
    fact: "Gillette Stadium in Foxborough, Massachusetts, has a lighthouse and bridge replica in the end zone.",
  },
  {
    id: 11,
    fact: "Ford Field in Detroit is partially built below ground level to keep it from obstructing the city's skyline.",
  },
  {
    id: 12,
    fact: "Allegiant Stadium in Las Vegas has a translucent roof and a large, retractable curtain behind one end zone offering a view of the Las Vegas Strip.",
  },
  {
    id: 13,
    fact: "The Buffalo Bills' Highmark Stadium is known for its cold and windy conditions due to its open design and location near Lake Erie.",
  },
  {
    id: 14,
    fact: "The San Francisco 49ers' Levi's Stadium has a rooftop garden and solar panels, making it one of the most environmentally friendly stadiums in the NFL.",
  },
  {
    id: 15,
    fact: "M&T Bank Stadium in Baltimore has a massive LED video display system with more than 16 million colors.",
  },
  {
    id: 16,
    fact: "SoFi Stadium in Inglewood, California, features the NFL's first double-sided 4K HDR video board, the Oculus.",
  },
  {
    id: 17,
    fact: "Lambeau Field is the only NFL stadium to have a private airport for teams located directly adjacent to the stadium.",
  },
  {
    id: 18,
    fact: "The Denver Broncos' Empower Field at Mile High is located exactly one mile above sea level.",
  },
  {
    id: 19,
    fact: "The New England Patriots’ Gillette Stadium features a 16-story lighthouse as part of its design.",
  },
  {
    id: 20,
    fact: "The Houston Texans' NRG Stadium was the first NFL stadium with a retractable roof.",
  },
  {
    id: 21,
    fact: "The Pittsburgh Steelers' Heinz Field features a massive Heinz ketchup bottle scoreboard that pours ketchup graphics when the Steelers enter the red zone.",
  },
  {
    id: 22,
    fact: "The Cleveland Browns' FirstEnergy Stadium is built on the shores of Lake Erie, making it subject to extreme weather conditions.",
  },
  {
    id: 23,
    fact: "The Jacksonville Jaguars' TIAA Bank Field features a unique pool area where fans can watch the game while swimming.",
  },
  {
    id: 24,
    fact: "The Philadelphia Eagles' Lincoln Financial Field uses wind turbines and solar panels to generate some of its own electricity.",
  },
  {
    id: 25,
    fact: "The Los Angeles Rams' and Los Angeles Chargers' SoFi Stadium is built on the former site of the Hollywood Park racetrack.",
  },
  {
    id: 26,
    fact: "The New York Giants' and New York Jets' MetLife Stadium can change its interior lighting colors to match the home team's colors for each game.",
  },
  {
    id: 27,
    fact: "The Green Bay Packers' Lambeau Field has a unique heated field system to prevent the ground from freezing.",
  },
  {
    id: 28,
    fact: "The Seattle Seahawks' Lumen Field was designed with acoustics in mind to amplify crowd noise.",
  },
  {
    id: 29,
    fact: "The Miami Dolphins' Hard Rock Stadium has hosted six Super Bowls, more than any other stadium.",
  },
  {
    id: 30,
    fact: "The New Orleans Saints' Superdome was the first NFL stadium to host a Super Bowl, Final Four, and the College Football Playoff National Championship.",
  },
  {
    id: 31,
    fact: "The Buffalo Bills' Highmark Stadium is one of the few NFL stadiums that does not have naming rights sold to a corporate sponsor.",
  },
  {
    id: 32,
    fact: "The Philadelphia Eagles' Lincoln Financial Field has a prison underneath the stadium for unruly fans.",
  },
  {
    id: 33,
    fact: "The Houston Texans' NRG Stadium can host multiple types of events, including the Houston Livestock Show and Rodeo.",
  },
  {
    id: 34,
    fact: "The New York Giants' and New York Jets' MetLife Stadium was the first NFL stadium to be shared by two teams.",
  },
  {
    id: 35,
    fact: 'The Green Bay Packers\' Lambeau Field is often referred to as the "Frozen Tundra."',
  },
  {
    id: 36,
    fact: "The Seattle Seahawks' Lumen Field has a roof that covers 70% of the seats but leaves the field exposed to the elements.",
  },
  {
    id: 37,
    fact: "The New Orleans Saints' Superdome is the largest fixed-dome structure in the world.",
  },
  {
    id: 38,
    fact: "The Houston Texans' NRG Stadium was the first NFL stadium to have a retractable roof.",
  },
  {
    id: 39,
    fact: "Tom Brady's strict diet and lifestyle regimen, known as the TB12 Method, includes avoiding certain foods like tomatoes and strawberries, which he believes has helped extend his career.",
  },
  {
    id: 40,
    fact: "Marshawn Lynch's love for Skittles started in high school and continued into the NFL, with fans throwing the candy onto the field after touchdowns.",
  },
  {
    id: 41,
    fact: "Chad Johnson (Ochocinco) often practiced catching passes during thunderstorms, believing it improved his concentration and focus during games.",
  },
  {
    id: 42,
    fact: "Brian Urlacher ate two chocolate chip cookies before every game as a superstition, which he believed helped his performance.",
  },
  {
    id: 43,
    fact: 'Ray Lewis performed a pre-game dance called the "Squirrel Dance," which became iconic and helped fire up both him and his teammates.',
  },
  {
    id: 44,
    fact: "Aaron Rodgers has a habit of meditating before games to enhance his focus and mental clarity.",
  },
  {
    id: 45,
    fact: "Michael Strahan's post-NFL career as a television personality helped him maintain his discipline and public speaking skills.",
  },
  {
    id: 46,
    fact: "Tony Gonzalez is an advocate for a plant-based diet, which he believes has improved his overall health and longevity in the NFL.",
  },
  {
    id: 47,
    fact: "Drew Brees meticulously keeps detailed journals of every game he has played, which helps him analyze and improve his performance.",
  },
  {
    id: 48,
    fact: "Troy Polamalu's long hair became his trademark, and he refused to cut it for years, believing it brought him good luck.",
  },
  {
    id: 49,
    fact: "Jerome Bettis' love for bowling translated into a disciplined and focused approach to football.",
  },
  {
    id: 50,
    fact: "Tony Romo is a scratch golfer and attempted to qualify for the U.S. Open, which helped him develop mental toughness and focus.",
  },
  {
    id: 51,
    fact: "Bo Jackson's dual-sport career in baseball and football showcased his exceptional athleticism and versatility.",
  },
  {
    id: 52,
    fact: "Hines Ward's participation in Dancing with the Stars helped him improve his footwork and agility on the field.",
  },
  {
    id: 53,
    fact: "Antonio Gates played college basketball and didn't play football until he entered the NFL, which helped him develop unique skills as a tight end.",
  },
  {
    id: 54,
    fact: "Randy Moss' love for fishing helped him relax and clear his mind during the NFL offseason.",
  },
  {
    id: 55,
    fact: "Joe Montana's post-NFL career as a vintner and winery owner helped him stay connected to a disciplined and structured lifestyle.",
  },
  {
    id: 56,
    fact: "DeMarcus Ware's love for music, including playing multiple instruments, helped him stay relaxed and focused during the NFL offseason.",
  },
  {
    id: 57,
    fact: "Tony Dorsett's pre-game meal routine of eating the same meal—spaghetti and meatballs—before every game contributed to his consistency on the field.",
  },
  {
    id: 58,
    fact: "Shannon Sharpe often brought his pet parrot to the team facility, which became a quirky signature and helped him stay relaxed.",
  },
  {
    id: 59,
    fact: "Derrick Thomas' superstition of wearing red shoes in honor of his late father helped him stay motivated and focused.",
  },
  {
    id: 60,
    fact: "Ray Nitschke's love of motorcycles helped him stay disciplined and focused during the NFL offseason.",
  },
  {
    id: 61,
    fact: "The longest NFL game ever played lasted 82 minutes and 40 seconds in a 1971 playoff game between the Kansas City Chiefs and the Miami Dolphins.",
  },
  {
    id: 62,
    fact: "The first Super Bowl was played on January 15, 1967, and was known as the AFL-NFL World Championship Game.",
  },
  {
    id: 63,
    fact: "The Pittsburgh Steelers have the most Super Bowl victories, with six.",
  },
  {
    id: 64,
    fact: 'The NFL’s “G” logo on the Green Bay Packers\' helmet stands for "Greatness," not "Green Bay."',
  },
  {
    id: 65,
    fact: "The New York Jets were originally called the New York Titans.",
  },
  {
    id: 66,
    fact: "The Chicago Bears were originally known as the Decatur Staleys.",
  },
  {
    id: 67,
    fact: "The first televised NFL game was broadcast on October 22, 1939.",
  },
  {
    id: 68,
    fact: "The Miami Dolphins are the only team to have a perfect season, going undefeated in 1972.",
  },
  {
    id: 69,
    fact: "The Buffalo Bills are the only team to have appeared in four consecutive Super Bowls (1991-1994) but lost all of them.",
  },
  {
    id: 70,
    fact: "The Dallas Cowboys have the most consecutive winning seasons (20) from 1966 to 1985.",
  },
  {
    id: 71,
    fact: "The NFL was founded in 1920 as the American Professional Football Association (APFA).",
  },
  {
    id: 72,
    fact: "The NFL's first draft was held in 1936.",
  },
  {
    id: 73,
    fact: "The Vince Lombardi Trophy, awarded to the Super Bowl champion, is named after the legendary Green Bay Packers coach.",
  },
  {
    id: 74,
    fact: "The Detroit Lions and the Dallas Cowboys always host games on Thanksgiving Day.",
  },
  {
    id: 75,
    fact: "The Los Angeles Rams were the first NFL team to have a logo on their helmets.",
  },
  {
    id: 76,
    fact: "The San Francisco 49ers were named after the prospectors who arrived in Northern California during the 1849 Gold Rush.",
  },
  {
    id: 77,
    fact: "The New England Patriots were originally called the Boston Patriots.",
  },
  {
    id: 78,
    fact: "The term “Hail Mary” pass was popularized by Roger Staubach after a 1975 playoff game.",
  },
  {
    id: 79,
    fact: "The NFL’s oldest rivalry is between the Green Bay Packers and the Chicago Bears, dating back to 1921.",
  },
  {
    id: 80,
    fact: "The Minnesota Vikings’ mascot is named “Viktor the Viking.”",
  },
  {
    id: 81,
    fact: "The NFL’s first African American head coach was Fritz Pollard in 1921.",
  },
  {
    id: 82,
    fact: "The NFL’s oldest stadium is Lambeau Field, home of the Green Bay Packers, which opened in 1957.",
  },
  {
    id: 83,
    fact: "The Tampa Bay Buccaneers lost their first 26 games as an expansion team in 1976-77.",
  },
  {
    id: 84,
    fact: "The Arizona Cardinals are the oldest continuously run professional football team in the United States, founded in 1898.",
  },
  {
    id: 85,
    fact: "The NFL’s first official championship game was held in 1933.",
  },
  {
    id: 86,
    fact: "The longest field goal in NFL history is 66 yards, kicked by Justin Tucker in 2021.",
  },
  {
    id: 87,
    fact: 'The "No Fun League" nickname was coined in response to the NFL\'s strict rules on player celebrations.',
  },
  {
    id: 88,
    fact: "The NFL’s Pro Bowl was first played in 1951.",
  },
  {
    id: 89,
    fact: "The first NFL player to rush for 2,000 yards in a season was O.J. Simpson in 1973.",
  },
  {
    id: 90,
    fact: "The NFL's first indoor stadium was the Houston Astrodome.",
  },
  {
    id: 91,
    fact: 'The Pittsburgh Steelers\' "Terrible Towel" was created by broadcaster Myron Cope in 1975.',
  },
  {
    id: 92,
    fact: "The NFL’s first game outside North America was played in 1983 in London, England.",
  },
  {
    id: 93,
    fact: "The highest-scoring game in NFL history was a 72-41 victory by the Washington Redskins over the New York Giants in 1966.",
  },
  {
    id: 94,
    fact: "The NFL's first female official, Sarah Thomas, was hired in 2015.",
  },
  {
    id: 95,
    fact: "The NFL’s most valuable franchise is the Dallas Cowboys.",
  },
  {
    id: 96,
    fact: "The longest punt in NFL history is 98 yards by Steve O'Neal in 1969.",
  },
  {
    id: 97,
    fact: "The NFL’s first live radio broadcast was in 1934.",
  },
  {
    id: 98,
    fact: 'The New Orleans Saints\' mascot is named "Gumbo the Dog."',
  },
  {
    id: 99,
    fact: "The NFL's first international regular-season game was played in Mexico City in 2005.",
  },
  {
    id: 100,
    fact: "The first African American quarterback to start a Super Bowl was Doug Williams in 1988.",
  },
  {
    id: 101,
    fact: "The NFL’s first 1,000-yard rusher was Beattie Feathers in 1934.",
  },
  {
    id: 102,
    fact: "The NFL’s first instant replay system was used in 1986.",
  },
  {
    id: 103,
    fact: "The first player to be drafted in the NFL Draft was Jay Berwanger in 1936.",
  },
  {
    id: 104,
    fact: "The longest touchdown pass in NFL history is 99 yards, achieved by multiple players.",
  },
  {
    id: 105,
    fact: "The NFL's first African American head coach to win a Super Bowl was Tony Dungy in 2007.",
  },
  {
    id: 106,
    fact: "The NFL's first Thanksgiving Day game was played in 1920.",
  },
  {
    id: 107,
    fact: "The first Super Bowl to be held indoors was Super Bowl XII in 1978.",
  },
  {
    id: 108,
    fact: "The NFL's first regular-season game played outside the United States was in Toronto in 2008.",
  },
  {
    id: 109,
    fact: "The longest win streak in NFL history is 23 games, held by the 2008-2009 Indianapolis Colts and the 2003-2004 New England Patriots.",
  },
  {
    id: 110,
    fact: "The NFL's first regular-season game was played on October 3, 1920.",
  },
  {
    id: 111,
    fact: "The first NFL team to win three Super Bowls in four years was the Dallas Cowboys.",
  },
  {
    id: 112,
    fact: "The first wildcard team to win a Super Bowl was the Oakland Raiders in 1980.",
  },
  {
    id: 113,
    fact: "The first player to rush for 100 touchdowns in his career was Jim Brown.",
  },
  {
    id: 114,
    fact: "The first NFL game to be played on artificial turf was in 1968.",
  },
  {
    id: 115,
    fact: "The first player to pass for over 4,000 yards in a season was Joe Namath in 1967.",
  },
  {
    id: 116,
    fact: "The first player to catch 100 passes in a season was Art Monk in 1984.",
  },
  {
    id: 117,
    fact: "The first player to record 20 sacks in a season was Mark Gastineau in 1984.",
  },
  {
    id: 118,
    fact: "The NFL's first Monday Night Football game was played on September 21, 1970.",
  },
  {
    id: 119,
    fact: "The first player to score 1,000 career points was Lou Groza.",
  },
  {
    id: 120,
    fact: "The first African American player drafted in the NFL was George Taliaferro in 1949.",
  },
  {
    id: 121,
    fact: "The first player to rush for over 10,000 career yards was Jim Brown.",
  },
  {
    id: 122,
    fact: "The first player to pass for over 50,000 career yards was Johnny Unitas.",
  },
  {
    id: 123,
    fact: "The first Super Bowl to be played on artificial turf was Super Bowl XIV in 1980.",
  },
  {
    id: 124,
    fact: "The first NFL team to be valued at over $1 billion was the Dallas Cowboys.",
  },
  {
    id: 125,
    fact: "The first player to record 1,000 career receptions was Jerry Rice.",
  },
  {
    id: 126,
    fact: "The first player to return a kickoff for a touchdown in the Super Bowl was Fulton Walker in Super Bowl XVII.",
  },
  {
    id: 127,
    fact: "The first Super Bowl to be played in the snow was Super Bowl XLVIII.",
  },
  {
    id: 128,
    fact: "The NFL’s first official mascot was Big Red of the St. Louis Cardinals.",
  },
  {
    id: 129,
    fact: "The first player to win the Heisman Trophy and the NFL MVP award was Paul Hornung.",
  },
  {
    id: 130,
    fact: "The first player to be enshrined in the Pro Football Hall of Fame was Don Hutson.",
  },
  {
    id: 131,
    fact: "The first player to win the Super Bowl MVP award twice was Bart Starr.",
  },
  {
    id: 132,
    fact: "The first NFL team to win back-to-back Super Bowls was the Green Bay Packers.",
  },
  {
    id: 133,
    fact: "The first player to intercept 14 passes in a single season was Night Train Lane.",
  },
  {
    id: 134,
    fact: "The first player to record 1,000 career tackles was Ray Lewis.",
  },
  {
    id: 135,
    fact: "The first player to record 100 career sacks was Reggie White.",
  },
  {
    id: 136,
    fact: "The first NFL team to win three Super Bowls was the Pittsburgh Steelers.",
  },
  {
    id: 137,
    fact: "The first player to return a punt for a touchdown in the Super Bowl was John Taylor in Super Bowl XXIII.",
  },
  {
    id: 138,
    fact: "The first player to record 100 career touchdown receptions was Don Hutson.",
  },
  {
    id: 139,
    fact: "The first player to pass for over 5,000 yards in a season was Dan Marino in 1984.",
  },
  {
    id: 140,
    fact: "The first player to record 200 career touchdowns was Jerry Rice.",
  },
  {
    id: 141,
    fact: "The first player to rush for 2,000 yards in a season was O.J. Simpson in 1973.",
  },
  {
    id: 142,
    fact: "The first player to catch 100 career touchdown passes was Steve Largent.",
  },
  {
    id: 143,
    fact: "The first player to record 1,000 career points was Lou Groza.",
  },
  {
    id: 144,
    fact: "The first player to pass for 400 career touchdowns was Dan Marino.",
  },
  {
    id: 145,
    fact: "The first player to return a punt for a touchdown in the Super Bowl was John Taylor in Super Bowl XXIII.",
  },
  {
    id: 146,
    fact: "The first player to record 1,000 career tackles was Ray Lewis.",
  },
  {
    id: 147,
    fact: "The first player to record 100 career sacks was Reggie White.",
  },
  {
    id: 148,
    fact: "The first player to rush for 2,000 yards in a season was O.J. Simpson in 1973.",
  },
  {
    id: 149,
    fact: "The first player to record 200 career touchdowns was Jerry Rice.",
  },
  {
    id: 150,
    fact: "The first player to record 100 career touchdown receptions was Don Hutson.",
  },
  {
    id: 151,
    fact: "The first player to pass for over 5,000 yards in a season was Dan Marino in 1984.",
  },
  {
    id: 152,
    fact: "The first player to record 1,000 career points was Lou Groza.",
  },
  {
    id: 153,
    fact: "The first player to return a punt for a touchdown in the Super Bowl was John Taylor in Super Bowl XXIII.",
  },
  {
    id: 154,
    fact: "The first player to record 1,000 career tackles was Ray Lewis.",
  },
  {
    id: 155,
    fact: "The first player to record 100 career sacks was Reggie White.",
  },
  {
    id: 156,
    fact: "The first player to rush for 2,000 yards in a season was O.J. Simpson in 1973.",
  },
  {
    id: 157,
    fact: "The first player to record 200 career touchdowns was Jerry Rice.",
  },
  {
    id: 158,
    fact: "The first player to record 100 career touchdown receptions was Don Hutson.",
  },
];
